<ds-modal
  #modelPricingModal
  [dimensionsConfig]="{ width: '600px' }"
  [ds-modal-trigger-for]="modelPricingModal"
  [(isModalOpen)]="modelPricingModalIsOpen"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Comments for <strong>{{updateCommentModalData.bodyNo}}</strong>
  </ds-box-header>
  <ds-box-content>
    <div>
          <div *ngIf="commentHistory && commentHistory.length > 0">
            <table class="ds-table zebra-table fixed-header-table">
              <thead>
                <tr class="table_head">
                  <th>Date</th>
                  <th>Time</th>
                  <th>User</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let history of commentHistory">
                  <td>{{history.zdate}}</td>
                  <td>{{history.ztime}}</td>
                  <td></td>
                  <td>{{history.zreserve}}</td>
                </tr>
              </tbody>
            </table>
            <br />
          </div>
      <span style="display: flex; align-items: center; gap: 8px">
        <div>
          <label ds-label for="mileageText" style="width: 200px">
            Please enter your comment:
          </label>
        </div>
        <div>
          <input
            style="width: 250px"
            ds-input
            id="mileageText"
            type="text"
            required
            placeholder="{{ updateCommentModalData.currentComment }}"
            (input)="onTextChange($event)"
            [(ngModel)]="commentModel"
          />
        </div>
      </span>
      <br />
    </div>




  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="outline"
      style="margin-right: 5px"
      (click)="submit('U')"
    >
      Remove
    </button>
    <button
      ds-button
      variant="primary"
      (click)="submit('N')"
    >
      Submit
    </button>
  </ds-box-footer>
</ds-modal>